import React from 'react'

const Section1 = () => {
    return (
        <div>
            <blockquote class="blockquote bq-primary">
               <h2 class="font-weight-bold text-center mb-4 bq-title">Abstract</h2>       
                    <p>I created MyBloggy website to encourage people to share their ideas, experiences, lifestyle, and knowledge.
                        Also, I would like to practice a new skill such as redux which I learned from the Udemy course, and enhance other programming skills for both front-end and back-end at the same time.
                         Furthermore, I would like to grab the data 
                        from MyBloggy because I would like to display information related to my blogs, which I have shared in MyBloggy,
                        into the blog page on my portfolio(This website).  
                    </p>      

                    <p>The proposed web-based application using HTML, CSS, JavaScript, react (hook), redux, express, NodeJs and mongoDB to develop 
                        a web application. The system consists of four main functions which are authentication, manage blog, manage comment and search blog
                    </p>
                </blockquote>

                <br/>
          <blockquote class="blockquote bq-danger">

<h2 class="font-weight-bold text-center my-4 bq-title">Objectives of the project</h2>
<h5>The objectives of the project include:</h5>
 <p className='note-danger'>
1. To develop a blog website to create a strong community.<br/>
2. To provide an alternative channel for people to share contents.<br/>
 </p>
 </blockquote>
 <br/>

 <blockquote class="blockquote bq-success">

<h2 class="font-weight-bold text-center my-4 bq-title">Expected Benefits</h2>

<h5>Benefits to Users</h5>
<p className='note-success'>
    1. Share contents easily <br/> 
    2. Access a good community<br/>
    3. Can see variety contents that they wish <br/>
 <br/>
</p>

<h5>Benefits to Developers</h5>
<p className='note-success'>
    1. Learn about website architecture and new website development frameworks. 
 <br/>
    2. Develop skills and knowledge of web programming using HTML, CSS, grid layout, JavaScript, GitHub, NPM, React, Redux and Database, etc.
<br/>
    3. Learn to develop a real-world application. 
<br/>
    4. Develop skills and knowledge in the software development process.
<br/> 
<br/>

</p>
</blockquote>
            
        </div>
    )
}

export default Section1
